import { render } from "./cjjj.vue?vue&type=template&id=7d54bf60"
import script from "./cjjj.vue?vue&type=script&lang=js"
export * from "./cjjj.vue?vue&type=script&lang=js"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__